export default {
	type: 'object',
	properties: {
		fileName: { type: 'string' },
		minutesTtl: { type: 'number' },
	},
	required: ['fileName'],
	additionalProperties: false,
}
